import styled from 'styled-components';
import ToolTip from '../ToolTip';
import UserImage from '../UserImage';
import { Badge } from 'react-bootstrap';

const StyledAvatarUserInfo = styled.span`
  text-transform: capitalize;
`;
function UserInfoAvatar({ user }) {
  return (
    <span className="d-flex align-items-center">
      <div className="me-1 position-relative">
        <UserImage
          avatar={user.image}
          userName={user.fullname || user.user}
          userId={String(user.id)}
        />
        <span className="avatar-profile-iscomplete-badge">
          {user.warnings && (
            <ToolTip warnings={user.warnings} isComplete={user.is_profile_updated} />
          )}
        </span>
      </div>

      <span className="d-block user-name">
        <StyledAvatarUserInfo>{user.fullname || user.user}</StyledAvatarUserInfo>
        <br />
        <small className="text-muted">
          {user?.employee_type || user?.role
            ? `${user?.employee_type || user?.active_role} - `
            : null}
          {user?.office_name ? `${user.office_name}` : null}
        </small>
      </span>
      {user.suspended && <Badge bg="danger">Suspended</Badge>}
    </span>
  );
}

export default UserInfoAvatar;
